import React from "react";
import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";

const estiloBoton = {
  backgroundColor: "white",
  "&:hover": { backgroundColor: "grey.50" },
};

// Franja con el cliente seleccionado y accesos a editar cliente / agregar dirección.
export default function ClienteSeleccionadoCard({
  clienteSeleccionado,
  direccionSeleccionada,
  onEditarCliente,
  onNuevaDireccion,
}) {
  return (
    <Grid item xs={12}>
      <Box
        sx={{
          backgroundColor: "primary.50",
          border: "1px solid",
          borderColor: "grey.700",
          borderRadius: 1,
          p: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "grey.500",
            }}
          />
          <Box>
            <Typography variant="subtitle2" fontWeight="600">
              {clienteSeleccionado.razon_social} - SISVEN:{" "}
              {direccionSeleccionada?.sisven_id} •
              {direccionSeleccionada?.nombre_sucursal || direccionSeleccionada?.sucursal}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: 0.6 }}>
          <Tooltip title="Editar cliente" placement="top" arrow>
            <IconButton size="small" onClick={onEditarCliente} sx={estiloBoton}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Agregar dirección" placement="bottom" arrow>
            <IconButton size="small" onClick={onNuevaDireccion} sx={estiloBoton}>
              <AddCircleIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Grid>
  );
}
